import React, { useContext, useState } from "react";
import "./Navbar.css";
// import dslLogo from "../../Assets/Images/dsl-logo.png";
import dslLogo from "../../Assets/Images/icon.png";
import { Link, useNavigate } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import closeIcon from "../../Assets/Images/close-icon.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { Dropdown } from "antd";

const aiCategories = [
  {
    category: "WRITE",
    items: [
      // { key: "22", path: "/text-ai", label: "TEXT AI" },
      { key: "44", path: "/business-plan-ai", label: "BUSINESS PLAN AI", hasAsterisk: true }
    ]
  },
  {
    category: "DESIGN",
    items: [
      { key: "23", path: "/image-ai", label: "IMAGE AI" },
      { key: "34", path: "/news-poster-ai", label: "NEWS POSTER AI" },
      { key: "42", path: "/poster-design-ai", label: "POSTER DESIGN AI" },
      { key: "31", path: "/social-post-ai", label: "SOCIAL POST AI", hasAsterisk: true },
      { key: "47", path: "/promo-campaign-ai", label: "PROMO CAMPAIGN AI" },
      { key: "43", path: "/toy-stories-ai", label: "TOY STORIES AI" }
    ]
  },
  {
    category: "VIDEO",
    items: [
      { key: "45", path: "/product-video-ai", label: "PRODUCT VIDEO AI" },
      { key: "27", path: "/comic-video-ai", label: "COMIC VIDEO AI", hasAsterisk: true },
      { key: "48", path: "/video-ai", label: "VIDEO AI", hasAsterisk: true }
    ]
  },
  {
    category: "AUDIO",
    items: [
      { key: "29", path: "/voice-ai", label: "VOICE AI" }
    ]
  },
  {
    category: "DISCOVER",
    items: [
      { key: "46", path: "/fact-of-the-day-ai", label: "FACT OF THE DAY AI" }
    ]
  }
];

const Navbar = () => {
  const [showOffCanvasOpen, setOffCanvasOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDropdown1, setOpenDropdown1] = useState(false);
  const [openDropdownAPI, setOpenDropdownAPI] = useState(false);
  const [openDesktopDropdownAPI, setOpenDesktopDropdownAPI] = useState(false);
  const [openDesktopDropdownMenu, setOpenDesktopDropdownMenu] = useState(false);
  const [openDesktopDropdownAccount, setOpenDesktopDropdownAccount] = useState(false);
  const [expandedDesktopCategories, setExpandedDesktopCategories] = useState({});
  const [expandedMobileCategories, setExpandedMobileCategories] = useState({});
  const { AIuser, AiLogOut } = useContext(UserAuthContext);
  const navigate = useNavigate();

  const goToRoute = (path) => {
    if (AIuser) {
      navigate(path);
    } else {
      navigate("/sign-in", { state: { from: path } });
    }
  };

  const items = [
    {
      key: "1",
      label: "DASHBOARD",
    },
    // {
    //   key: "2",
    //   label: "PURCHASE",
    // },
    {
      key: "3",
      label: "PURCHASE HISTORY",
    },
    {
      key: "4",
      label: "PAYMENT METHODS",
    },
    {
      key: "5",
      label: "USAGE",
    },
    {
      key: "6",
      label: "EARNINGS",
    }
  ];


  const handleMenuClick = (e) => {
    if (e.key === "1") {
      goToRoute("/dashboard");
    }
    else if (e.key === "2") {
      goToRoute("/purchase");
    } else if (e.key === "3") {
      goToRoute("/purchase-history");
    } else if (e.key === "4") {
      goToRoute("/payment-methods");
    } else if (e.key === "5") {
      goToRoute("/usage");
    } else if (e.key === "6") {
      goToRoute("/earnings");
    }
    else if (e.key === "16") {
      goToRoute("/api-settings");
    }
    else if (e.key === "61") {
      goToRoute("/social-media-logins");
    }
  };

  const handleMenu = (e) => {
    if (e.key && e.key.startsWith('cat_')) {
      const category = e.key.replace('cat_', '');
      setExpandedDesktopCategories(prev => ({ ...prev, [category]: !prev[category] }));
      return;
    }
    if (e.key === "7") {
      navigate("/about-us");
    } else if (e.key === "8") {
      navigate("/pricing");
    } else if (e.key === "9") {
      navigate("/artificial-intelligence");
    } else if (e.key === "10") {
      navigate("/generative-ai");
    } else if (e.key === "11") {
      // navigate("/contact-us");
      navigate("/social-media-marketing");
      // } else if (e.key === "12") {
      //   navigate("/api");
    } else if (e.key === "13") {
      // navigate("/do-it-yourself");
    }
    // else if (e.key === "14") {
    //   navigate("/let-us-do-it-for-you");
    // }
    else if (e.key === "15") {
      navigate("/how-it-works");
    }
    else if (e.key === "32") {
      navigate("/faq");
    }
    else if (e.key === "33") {
      navigate("/support");
    }
    else if (e.key === "17") {
      navigate("/contents");
    }


    else if (e.key === "21") goToRoute("/social-media-consultant");
    // else if (e.key === "22") goToRoute("/text-ai");
    else if (e.key === "23") goToRoute("/image-ai");
    // else if (e.key === "24") goToRoute("/post-ai");
    else if (e.key === "31") goToRoute("/social-post-ai");
    else if (e.key === "34") goToRoute("/news-poster-ai");
    else if (e.key === "42") goToRoute("/poster-design-ai");
    else if (e.key === "45") goToRoute("/product-video-ai");
    // else if (e.key === "25") goToRoute("/text-video-ai");
    // else if (e.key === "26") goToRoute("/news-video-ai");
    else if (e.key === "27") goToRoute("/comic-video-ai");
    else if (e.key === "48") goToRoute("/video-ai");
    else if (e.key === "29") goToRoute("/voice-ai");
    // else if (e.key === "30") goToRoute("/developer-ai");
    else if (e.key === "44") goToRoute("/business-plan-ai");
    else if (e.key === "43") goToRoute("/toy-stories-ai");
    else if (e.key === "46") goToRoute("/fact-of-the-day-ai");
    else if (e.key === "47") goToRoute("/promo-campaign-ai");

    // else if (e.key === "28") {
    //   navigate("/api");
    // }
  };

  const handleOpenDropdown = (e) => {
    setOpenDropdown(!openDropdown);
  };
  const handleOpenDropdown1 = (e) => {
    setOpenDropdown1(!openDropdown1);
  };
  const handleOpenDropdownAPI = (e) => {
    setOpenDropdownAPI(!openDropdownAPI);
  }

  const toggleDesktopCategory = (e, category) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandedDesktopCategories(prev => ({ ...prev, [category]: !prev[category] }));
  };

  const toggleMobileCategory = (e, category) => {
    e.preventDefault();
    e.stopPropagation();
    setExpandedMobileCategories(prev => ({ ...prev, [category]: !prev[category] }));
  };

  const desktopAiItems = [];
  aiCategories.forEach(cat => {
    desktopAiItems.push({
      key: `cat_${cat.category}`,
      label: (
        <div
          onClick={(e) => toggleDesktopCategory(e, cat.category)}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'bold' }}
        >
          <span>{cat.category}</span>
          <i className={`fa-solid ${expandedDesktopCategories[cat.category] ? 'fa-caret-up' : 'fa-caret-down'}`} style={{ marginLeft: '15px' }} />
        </div>
      )
    });
    if (expandedDesktopCategories[cat.category]) {
      cat.items.forEach(child => {
        desktopAiItems.push({
          key: child.key,
          label: (
            <span style={{ paddingLeft: '15px' }}>
              {child.label}
              {child.hasAsterisk && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
            </span>
          )
        });
      });
    }
  });

  desktopAiItems.push({
    key: "disclaimer",
    label: (
      <div style={{ paddingLeft: '0px', fontSize: '10px', color: 'gray', whiteSpace: 'normal', maxWidth: '250px', marginTop: '10px' }}>
        <span style={{ color: 'red' }}>*</span> To avoid waiting, the AI will process your request in the background and send the completed result directly to your email.
      </div>
    ),
    disabled: true,
  });

  const mobileDropdownPaths = [
    { path: `${AIuser ? "/dashboard" : "/sign-in"}`, label: "DASHBOARD" },
    // { path: `${AIuser ? "/purchase" : "/sign-in"}`, label: "PURCHASE" },
    {
      path: `${AIuser ? "/purchase-history" : "/sign-in"}`,
      label: "PURCHASE HISTORY",
    },
    {
      path: `${AIuser ? "/payment-methods" : "/sign-in"}`,
      label: "PAYMENT METHODS",
    },
    { path: `${AIuser ? "/usage" : "/sign-in"}`, label: "USAGE" },
    { path: `${AIuser ? "/earnings" : "/sign-in"}`, label: "EARNINGS" },
    // { path: `${AIuser ? "/api-settings" : "/sign-in"}`, label: "API SETTINGS" },
    // { path: `${AIuser ? "/social-media-logins" : "/sign-in"}`, label: "SOCIAL MEDIA LOGINS" },
  ];

  const mobileDropdownPaths2 = [
    { path: "/about-us", label: "About Us" },
    { path: "/pricing", label: "Pricing" },

    // { path: "/contact-us", label: "Contact Us" },
    // { path: "/api", label: "API" },

    // hide To DO 
    // { path: "/artificial-intelligence", label: "Artificial Intelligence" },
    // {
    //   path: "/generative-ai",
    //   label: "Generative AI",
    // },
    // { path: "/social-media-marketing", label: "Social Media Marketing" },
    { path: "/how-it-works", label: "How it works" },
    { path: "/contents", label: "CONTENTS" },
    // { path: "/do-it-yourself", label: "Do it" },
    { path: "/faq", label: "FAQ" },
    { path: "/support", label: "Support" },
    // { path: "/let-us-do-it-for-you", label: "Let us do it for you" },
    // { path: "/api", label: "API" },
  ];

  return (
    <div className="navbar-container d-flex align-items-center">
      <div className="navbar-main container">
        <div className="nav-left d-flex align-items-center">
          <Link to={"/"}>
            <img className="dsl-logo" src={dslLogo} alt="dslLogo" />
          </Link>

          <h1
            className="text-white ms-3 mb-0 d-lg-block d-md-block d-none"
            style={{ fontSize: "24px", cursor: "pointer" }}
            onClick={() => goToRoute("/")}
          >
            WHALESAI.COM
          </h1>
        </div>
        <div className="d-lg-none d-md-none d-block">
          <h1
            className="text-white my-4 custom-width-title-content"
            style={{ fontSize: "24px", cursor: "pointer" }}
            onClick={() => goToRoute("/")}
          >
            WHALESAI.COM
          </h1>
        </div>
        <div className="nav-right">
          <div className="nav-menus-in-large d-none d-lg-flex">
            <li>
              <a
                className="text-uppercase consultant-color"
                style={{ cursor: "pointer", display: "flex", alignItems: "center", height: "100%" }}
                onClick={() => goToRoute("/social-media-consultant")}
              >
                SOCIAL MEDIA CONSULTANT
              </a>
            </li>

            <Dropdown
              menu={{
                items: desktopAiItems,
                selectable: true,
                defaultSelectedKeys: ["7"], // Set default selected key as needed
                onClick: handleMenu,
              }}
              trigger={["click"]}
              onOpenChange={(open) => setOpenDesktopDropdownAPI(open)}
              arrow={{
                pointAtCenter: true,
              }}
              className="text-uppercase"
            >
              <li>
                <a
                  className="text-light text-uppercase"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  AI TOOLS{" "}
                  {openDesktopDropdownAPI ? (
                    <i className="fa-solid fa-caret-up"></i>
                  ) : (
                    <i className="fa-solid fa-caret-down"></i>
                  )}
                </a>
              </li>
            </Dropdown>

            <Dropdown
              menu={{
                items: [
                  { key: "7", label: "ABOUT US" },
                  { key: "8", label: "PRICING" },
                  // Hide To Do 
                  // { key: "9", label: "ARTIFICIAL INTELLIGENCE" },
                  // { key: "10", label: "GENERATIVE AI" },
                  // { key: "11", label: "SOCIAL MEDIA MARKETING" },
                  // { key: "12", label: "API" },
                  { key: "15", label: "HOW IT WORKS" },
                  { key: "17", label: "CONTENTS" },
                  // { key: "13", label: "DO IT" }, //#011225
                  { key: "32", label: "FAQ" },
                  { key: "33", label: "SUPPORT" },
                  // { key: "14", label: "LET US DO IT FOR YOU", style: { backgroundColor: "#6960ED", color: "white", marginTop: "2px" } },
                  // { key: "28", label: "API" },
                ],
                selectable: true,
                // items: menuItems,
                defaultSelectedKeys: ["7"], // Set default selected key as needed
                onClick: handleMenu,

              }}
              trigger={["click"]}
              onOpenChange={(open) => setOpenDesktopDropdownMenu(open)}
              arrow={{
                pointAtCenter: true,
              }}
              className="text-uppercase"
            >
              <li>
                <a
                  className="text-light text-uppercase"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  MENU{" "}
                  {openDesktopDropdownMenu ? (
                    <i className="fa-solid fa-caret-up"></i>
                  ) : (
                    <i className="fa-solid fa-caret-down"></i>
                  )}
                </a>
              </li>
            </Dropdown>

            {AIuser?._id && (
              <Dropdown
                menu={{
                  items,
                  selectable: true,
                  defaultSelectedKeys: ["1"],
                  onClick: handleMenuClick,
                }}
                trigger={["click"]}
                onOpenChange={(open) => setOpenDesktopDropdownAccount(open)}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li>
                  <a
                    className="text-light"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    ACCOUNT{" "}
                    {openDesktopDropdownAccount ? (
                      <i className="fa-solid fa-caret-up"></i>
                    ) : (
                      <i className="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              </Dropdown>
            )}

            <li>
              {AIuser?._id ? (
                <button
                  onClick={() => {
                    AiLogOut();
                    navigate("/");
                  }}
                  className="login-button"
                >
                  Sign out
                </button>
              ) : (
                <button
                  onClick={() => navigate("/sign-in")}
                  className="login-button"
                >
                  Sign in
                </button>
              )}
            </li>
          </div>
          <div className="ham-burger-container d-lg-none">
            <button
              onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
              className="ham-burger-button"
            >
              <i class="fa-solid fa-bars"></i>
            </button>
          </div>
        </div>

        {/* OFF CANVAS */}
        <Offcanvas
          show={showOffCanvasOpen}
          onHide={() => setOffCanvasOpen(!showOffCanvasOpen)}
          placement="end"
        >
          <div className="close-button-container">
            <button
              onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
              className="offcanvas-close-button"
            >
              <img src={closeIcon} alt="closeIcon" />
            </button>
          </div>
          <Offcanvas.Body>
            <div
              // onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
              className="off-canvas-menus-container"
            >
              {/* Social Media Consultant */}
              <li onClick={() => {
                setOffCanvasOpen(!showOffCanvasOpen);
                goToRoute("/social-media-consultant");
              }}>
                <a className="text-uppercase consultant-color" style={{ cursor: "pointer", color: "yellow" }}>
                  SOCIAL MEDIA CONSULTANT
                </a>
              </li>

              {/* API Dropdown  */}
              <li
                menu={{
                  items: [
                    { "key": "44", "label": "BUSINESS PLAN AI" },
                    { "key": "27", "label": "COMIC VIDEO AI" },
                    { "key": "46", "label": "FACT OF THE DAY AI" },
                    // { "key": "30", "label": "DEVELOPER AI" },
                    { "key": "23", "label": "IMAGE AI" },
                    { "key": "47", "label": "PROMO CAMPAIGN AI" },
                    // { "key": "26", "label": "NEWS VIDEO AI" },
                    { "key": "31", "label": "SOCIAL POST AI" },
                    { "key": "42", "label": "POSTER DESIGN AI" },
                    { "key": "45", "label": "PRODUCT VIDEO AI" },
                    // { "key": "24", "label": "POST AI" },
                    { "key": "22", "label": "TEXT AI" },
                    // { "key": "25", "label": "TEXT VIDEO AI" },
                    { "key": "43", "label": "TOY STORIES AI" },
                    { "key": "29", "label": "VOICE AI" }
                  ],
                  selectable: true,
                  defaultSelectedKeys: ["7"], // Set default selected key as needed
                  // onClick: handleMenu,
                }}
                trigger={["click"]}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li onClick={handleOpenDropdownAPI}>
                  <a
                    className="text-light text-uppercase"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    AI TOOLS{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              </li>


              {/* API drop down  */}
              {openDropdownAPI && (
                <div style={{ width: '100%', paddingLeft: '10px' }}>
                  {aiCategories.map((cat) => (
                    <React.Fragment key={cat.category}>
                      <li
                        onClick={(e) => toggleMobileCategory(e, cat.category)}
                        style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: "10px" }}
                        className="text-primary"
                      >
                        <span className="text-uppercase text-light" style={{ fontWeight: "bold" }}>{cat.category}</span>
                        <i className={`fa-solid ${expandedMobileCategories[cat.category] ? 'fa-caret-up' : 'fa-caret-down'} text-light`} />
                      </li>
                      {expandedMobileCategories[cat.category] && (
                        <div style={{ paddingLeft: '10px' }}>
                          {cat.items.map(child => (
                            <li
                              onClick={() => {
                                setOffCanvasOpen(!showOffCanvasOpen)
                                goToRoute(child.path);
                              }}
                              key={child.label}
                              className="text-primary"
                            >
                              <span className="text-uppercase text-warning">
                                {child.label}
                                {child.hasAsterisk && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                              </span>
                            </li>
                          ))}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                  <div style={{ paddingLeft: '0px', fontSize: '10px', color: 'gray', marginTop: '10px', paddingRight: '10px', whiteSpace: 'normal' }}>
                    <span style={{ color: 'red' }}>*</span> To avoid waiting, the AI will process your request in the background and send the completed result directly to your email.
                  </div>
                </div>
              )}


              <hr
                style={{
                  color: "white",
                  backgroundColor: "white",
                  width: "50%",
                  height: "2px",
                }}
              />
              <li
                menu={{
                  items: [
                    { key: "7", label: "About Us" },
                    { key: "8", label: "Pricing" },
                    { key: "9", label: "Artificial Intelligence" },
                    { key: "10", label: "Generative AI" },
                    { key: "11", label: "API" },
                    // { key: "12", label: "Do it" },
                    { key: "13", label: "Let us do it for you" },
                    { key: "15", label: "HOW IT WORKS" },
                    { key: "17", label: "CONTENTS" },
                    { key: "28", label: "API" },
                  ],
                  selectable: true,
                  defaultSelectedKeys: ["7"], // Set default selected key as needed
                  // onClick: handleMenu,
                }}
                trigger={["click"]}
                arrow={{
                  pointAtCenter: true,
                }}
              >
                <li onClick={handleOpenDropdown}>
                  <a
                    className="text-light text-uppercase"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    MENU{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              </li>

              {openDropdown && (
                <>
                  {mobileDropdownPaths2?.map(({ path, label }) => (
                    <li
                      onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
                      key={label}
                      className="text-primary"
                    >
                      {/* <Link className={`text-uppercase ${label === 'DO IT YOURSELF' || label === 'Let us do it for you' ? 'text-primary' : 'text-warning'}`} to={path}>
                        {label}
                      </Link> */}
                      {/* <Link className={`text-uppercase ${label === 'Do it yourself' ? 'text-blue' : 'text-warning'}`} to={path}>
                        {label}
                      </Link> */}
                      <Link
                        className="text-uppercase"
                        // style={{ color: label === 'DO IT YOURSELF' || label === 'Let us do it for you' ? '#A9D1FF' : '#FFD700' }}
                        style={{
                          //#E76F51
                          color: '#FFD700'
                        }}
                        to={path}
                      >
                        {label}
                      </Link>

                    </li>
                  ))}
                </>
              )}

              <hr
                style={{
                  color: "white",
                  backgroundColor: "white",
                  width: "50%",
                  height: "2px",
                }}
              />
              {AIuser?._id && (
                <li onClick={handleOpenDropdown1}>
                  <a
                    className="text-light"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    ACCOUNT{" "}
                    {openDropdown ? (
                      <i class="fa-solid fa-caret-up"></i>
                    ) : (
                      <i class="fa-solid fa-caret-down"></i>
                    )}
                  </a>
                </li>
              )}
              {openDropdown1 && (
                <>
                  {mobileDropdownPaths?.map(({ path, label }) => (
                    <li
                      onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}
                      key={label}
                      className="text-primary"
                    >
                      <Link className="text-warning text-uppercase" to={path}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </>
              )}

              <li onClick={() => setOffCanvasOpen(!showOffCanvasOpen)}>
                {AIuser?._id ? (
                  <button
                    onClick={() => {
                      AiLogOut();
                      navigate("/");
                    }}
                    className="login-button"
                  >
                    Sign out
                  </button>
                ) : (
                  <button
                    onClick={() => navigate("/sign-in")}
                    className="login-button"
                  >
                    Sign in
                  </button>
                )}
              </li>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </div >
  );
};

export default Navbar;
